var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('Icon',{staticClass:"n-success",attrs:{"custom":"fas fa-check","size":"15"}}):_c('Icon',{staticClass:"n-error",attrs:{"custom":"fas fa-times","size":"15"}})
}
var staticRenderFns = []

export { render, staticRenderFns }